import React from "react";

const InterventionCreateNote = () => {
  return (
    <div className="bg-white p-2  flex flex-col max-w-[355px] ">
      <p className="text-gray-800 text-sm  font-normal">
        Complete Interventions in the "Intervention" tab. Can also access
        Interventions via Clinicals.
      </p>
    </div>
  );
};

export default InterventionCreateNote;
